import React from 'react';
import { useTranslation } from 'react-i18next';

import { ResetFilterIcon } from '@/shared/assets/icons/reset-filter-icon';
import { ConfirmDialog } from '@/shared/components/ui/confirm-dialog/confirm-dialog';
import { MenuItem } from '@/shared/components/ui/menu-item/menu-item';
import { useResetTableViews } from '@/shared/features/filter-preferences/hooks/use-reset-table-views/use-reset-table-views';

export const ResetTableViews: React.FC = () => {
  const { t } = useTranslation();
  const { hasCustomViews, resetTableViews } = useResetTableViews();

  if (!hasCustomViews) {
    return null;
  }

  return (
    <ConfirmDialog
      triggerComponent={
        <MenuItem icon={<ResetFilterIcon />}>
          {t('ui:table_view.reset_all')}
        </MenuItem>
      }
      headline={t('ui:table_view.reset_all_confirmation')}
      successMessage={t('ui:table_view.reset_all_success')}
      errorMessage={t('ui:table_view.reset_all_error')}
      primaryButtonLabel={t('common:confirm')}
      primaryButtonVariant="alert"
      mutation={resetTableViews}
    />
  );
};
